import { g as getInputId } from './getInputId-aa144169.js';

function getPushButtonId(name, baseId) {
  return getInputId(name, baseId, "-push");
}

export { getPushButtonId as g };
